module.exports = __webpack_public_path__ + "img/person-carry-box.6fb6d553.svg";